import Chart from "common/components/Chart/Chart";
import { usePieChart } from "hooks/chart/UsePieChart";
import React, { useEffect } from "react";
import { MOREGRAPH } from "utils/constants";

const PieChart = ({ data, xAxis }) => {
    const {
        options: optionsPieChart,
        setOptions: setOptionsPieChart,
        showLoading,
        hideLoading,
    } = usePieChart();

    useEffect(() => {
        if ("data" in data && Object.keys(data).length > 0) {
            showLoading(); // 🔹 Mostrar loading

            setTimeout(() => {
                setOptionsPieChart({
                    ...optionsPieChart,
                    series: [
                        {
                            ...optionsPieChart.series[0],
                            data: data.data.map((obj) => ({
                                name: obj[`group_by_${xAxis}`][xAxis],
                                y: (obj.count / data.total) * 100,
                            })),
                        },
                    ],
                });
                hideLoading();
            }, 100);
        } else {
            setOptionsPieChart({
                ...optionsPieChart,
                series: [
                    {
                        ...optionsPieChart.series[0],
                        data: [],
                    },
                ],
            });
        }
    }, [data]);

    return (
        <Chart
            options={optionsPieChart}
            type={MOREGRAPH}
            onChartReady={(chart) => {
                showLoading.chartRef = chart;
            }}
        />
    );
};

export default PieChart;
